<template>
  <div class="hr" />
</template>
<script>
export default {
  name: 'Hr',
}
</script>
<style scoped lang="scss">
.hr {
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
  border-bottom: 1px solid #e2e2e2;
}
</style>
